import { render, staticRenderFns } from "./go-login-modal.vue?vue&type=template&id=4af1ecaf"
import script from "./go-login-modal.vue?vue&type=script&lang=js"
export * from "./go-login-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports